import type { FaireProductEntity } from "../../entity_types/product";

export const p_77kp5x4scg: FaireProductEntity = {
  token: "p_77kp5x4scg",
  type: "product",
  name: "Lymphatic Support Facial Dry Brush | Face Sculpting",
  brandToken: "b_m3n7j6u3h2",
  brandName: "Salt + Soul Skincare",
  imageUrl:
    "https://cdn.faire.com/fastly/7ac67150f1a3bb39ef0aa4221a11633476f936bb7c5086a0b37459f5e87dfeba.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e21f393bac39904178dda495d05806196a6d260e63a4ccf8669a2a5332fe169.png",
    "https://cdn.faire.com/fastly/a78194f0c1cc9d9c11a6548ba60596468b69db7597fdcded1f83718c208e68e7.png",
    "https://cdn.faire.com/fastly/e5311e0ed9f22a8f7f097088e7374e17056f714c90fb5142d662711ca4ded354.png",
    "https://cdn.faire.com/fastly/f91d8b8b0365ff5cb1e1fb593b7d90631ececa154df03368d676fa4e062cafc7.png",
    "https://cdn.faire.com/fastly/9705b8a09a95038ef5dba0f3ae693dc2edde55e1ed42b278cef930dee3bb9bee.png",
    "https://cdn.faire.com/fastly/17297c7e34aa8f5cad80b00bfb654b5ded29fb3d65150342c30bbf9e2a0c1fe1.png",
    "https://cdn.faire.com/fastly/b1e6a209674987e6e117748047532ffd1a72e7061045983db5d4d8faabcc2a9b.png",
  ],
  priceDollars: 12.5,
  description:
    "A grounding ritual for skin that feels awakened and refreshed.\n\nOur palm sized facial dry brush is designed to gently stimulate the skin, support natural lymphatic wellness, and encourage a more lifted, sculpted appearance. \n\nUse on dry skin before moisturizing. Sweep outward and downward toward the neck with soft, intentional strokes to help:\n\n✨ Refresh dull, tired looking skin\n✨ Reduce the appearance of puffiness\n✨ Encourage a naturally sculpted glow\n✨ Gently exfoliate for smoother texture\n\nSoft yet durable bristles. Cruelty free, vegan bristles-no animal hair.\n\nSimple. Effective. Ritual worthy.\n\nPair with your favorite Salt + Soul oil to seal in hydration and feel good in your skin.\n\n-Comes with a hard plastic case, 4x6 cotton muslin pouch, and a 3x5 diagram card. \n\nPlastic cases or labels can be omitted on request.\n\nUSA Family run business\n\n-This product is for cosmetic use only. Results may vary. Not intended to diagnose, treat, prevent, or cure any disease.-",
  tags: [],
  msrpDollars: 25,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:38:50.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
